import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { fmtDateTime } from "@/lib/checkins";
import { DiaryReport } from "../staff/DiaryReport";
import { errMsg } from "../staff/ResolveDialog";

/** Staff look at a diary that is still open (read-only; the client keeps editing). */
export function DiaryProgressDialog({ iid, onClose }) {
  const [d, setD] = useState(null);
  useEffect(() => {
    api.get(`/checkin-invitations/${iid}/diary`).then((r) => setD(r.data))
      .catch((e) => { toast.error("Couldn't load the diary", { description: errMsg(e) }); onClose(); });
  }, [iid]); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-h-[90vh] max-w-3xl overflow-y-auto" data-testid="diary-progress-dialog">
        <DialogHeader><DialogTitle>{d?.config?.name || "Diary"} — in progress</DialogTitle></DialogHeader>
        {!d ? <Loader2 className="h-5 w-5 animate-spin text-zinc-400" /> : (
          <div className="space-y-3">
            <p className="text-sm text-zinc-600" data-testid="diary-progress-meta">
              {d.draft_saved_at ? `Last saved ${fmtDateTime(d.draft_saved_at)}` : "Nothing saved yet"} · closes {fmtDateTime(d.closes_at)}.
              The client can still add and change entries. You&apos;re flagged when it&apos;s sent, or straight away if a flag rule is met.
            </p>
            <DiaryReport config={d.config} diary={d.diary} summary={d.summary} flags={d.flags} start={d.calendar[0]?.date} />
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
